export const REQUEST_LANGUAGES = 'app/languages/REQUEST_LANGUAGES';
export const REQUEST_LANGUAGES_SUCCESS = 'app/languages/REQUEST_LANGUAGES_SUCCESS';
export const REQUEST_LANGUAGES_FAILURE = 'app/languages/REQUEST_LANGUAGES_FAILURE';
